module.exports = __webpack_public_path__ + "img/bg_guojiaguangdian.013c4e04.png";